import { render } from "./ArchaicGeoJsonMap.vue?vue&type=template&id=11190137"
import script from "./ArchaicGeoJsonMap.vue?vue&type=script&lang=js"
export * from "./ArchaicGeoJsonMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__